// Bedrijfsgegevens van AMUMIN B.V. voor de ouderapp (art. 3:15d BW: naam, adres en KvK-nummer op
// een bedrijfswebsite; ook de app op amumin.app is dat). EEN plek: de ouderapp toont ze bij
// Instellingen, onder de privacyverklaring en onder de inlogschermen. De verkoopsite
// (apps/site/src/site.config.ts) houdt zijn eigen kopie; apps/web/src/lib/company.test.ts bewaakt
// dat beide gelijk zijn.
export const COMPANY = {
    name: 'AMUMIN B.V.',
    kvk: '92851479',
    street: 'Schiedamseweg 31-A',
    postcodeCity: '3026 AB Rotterdam',
    email: 'info@amumin.com',
};
/** "Schiedamseweg 31-A, 3026 AB Rotterdam" */
export function companyAddress() {
    return `${COMPANY.street}, ${COMPANY.postcodeCity}`;
}
//# sourceMappingURL=company.js.map